import React, { type FC } from "react";
import { useDivisionFilterSeed } from "@app/session-defaults/useDivisionFilterSeed";
import { BoType } from "@src/api/bo";
import { DivisionType } from "@src/api/dictionaries/divisions";
import { BoStateSelect, DivisionSearchSelect } from "@src/components/business-data-entry";
import { BusinessForm } from "@src/components/business-form";
import { FilterFormPanel } from "@shared/ui/form-panel";
import { Input } from "@shared/ui/input";
import type { ActOfCheckingAvailabilityFilter } from "../../../../../../api/actOfCheckingAvailability";
import type { ListFilterPanelProps } from "../../../../../../shared/listFilterPanel";
import {
    stockPartialInventoryFilterFormConfig,
    type StockPartialInventoryFilterFormValues,
} from "./stockPartialInventoryFilter.form-config";

/** Пропсы компонента {@link StockPartialInventoryFilterForm}. */
export type StockPartialInventoryFilterFormProps = ListFilterPanelProps<ActOfCheckingAvailabilityFilter>;

/** Форма фильтра списка АПН для частичной инвентаризации склада. */
export const StockPartialInventoryFilterForm: FC<StockPartialInventoryFilterFormProps> = ({ initialFilter, onApply }) => {
    const seed = useDivisionFilterSeed<StockPartialInventoryFilterFormValues>("divisionCode", {
        filter: { Types: [DivisionType.Склад] },
    });

    return (
        <FilterFormPanel
            initialFilter={initialFilter}
            seed={seed}
            submissionMemory={{
                key: "stock.partialInventory.filter",
                schemaVersion: 1,
                fields: ["divisionCode", "stateCodes"],
            }}
            formProps={{ formConfig: stockPartialInventoryFilterFormConfig }}
            toForm={(filter) => stockPartialInventoryFilterFormConfig.toForm(filter)}
            toDomain={(values) => stockPartialInventoryFilterFormConfig.toDomain(values)}
            onApply={onApply}
        >
            {(form) => (
                <>
                    <BusinessForm.Field name="divisionCode">
                        <DivisionSearchSelect
                            {...form.field("divisionCode").getSearchSelectProps((division) => division?.Code ?? null)}
                            flt={{ Types: [DivisionType.Склад] }}
                            fullscreenTitle="Выберите Склад АПН"
                        />
                    </BusinessForm.Field>
                    <BusinessForm.Field name="num">
                        <Input {...form.field("num").getPropsWithLabel()} />
                    </BusinessForm.Field>
                    <BusinessForm.Field name="stateCodes">
                        <BoStateSelect
                            {...form.field("stateCodes").getControlledPropsWithLabel()}
                            boType={BoType["Акт проверки наличия"]}
                            multiple
                            clearable
                            fullscreenTitle="Выберите статус(ы) АПН"
                        />
                    </BusinessForm.Field>
                </>
            )}
        </FilterFormPanel>
    );
};
